import { useDisclosure } from '@mantine/hooks';
import { createContext, useContext, useMemo, useState } from 'react';
import SyncRemoteDeviceModal from 'components/modals/sync-remote-device-modal/SyncRemoteDeviceModal';
import { SyncRemoteDeviceModalProps } from 'components/modals/sync-remote-device-modal/SyncRemoteDeviceModal';

type OpenSyncRemoteDeviceModalParams = Omit<SyncRemoteDeviceModalProps, 'opened' | 'onClose'>;
type OpenSyncRemoteDeviceModal = (params?: OpenSyncRemoteDeviceModalParams) => void;

interface ISyncRemoteDeviceModalContext {
  openSyncRemoteDeviceModal: OpenSyncRemoteDeviceModal;
}

const SyncRemoteDeviceModalContext = createContext<ISyncRemoteDeviceModalContext>(undefined!);

/**
 * Provider for marking the device's fault as fixed.
 */
export function SyncRemoteDeviceModalProvider({ children }: { children: React.ReactNode }) {
  const [opened, { close, open }] = useDisclosure(false);
  const [params, setParams] = useState<OpenSyncRemoteDeviceModalParams | undefined>(undefined);

  /**
   * Opens the modal for copying table profiles.
   */
  const openSyncRemoteDeviceModal: OpenSyncRemoteDeviceModal = (params) => {
    setParams(params);
    open();
  };

  const value = useMemo(() => ({ openSyncRemoteDeviceModal }), [openSyncRemoteDeviceModal]);

  return (
    <SyncRemoteDeviceModalContext.Provider value={value}>
      {children}
      {opened && <SyncRemoteDeviceModal opened onClose={close} {...params!} />}
    </SyncRemoteDeviceModalContext.Provider>
  );
}

/**
 * Hook for marking the device's fault as fixed.
 */
export function useSyncRemoteDeviceModal() {
  return useContext(SyncRemoteDeviceModalContext);
}
